export class ItemsProspectoPropuestaOperacion {
    Id_IPPO?: number = 0;
    //idItemsProspectoPropuestaOperacion: number = 0;
    idPropuestaOperacion: number = 0;
    idItemsProspecto: number = 0;
    Observaciones: string = '';
    checked?: boolean;    
}